import introJs from 'intro.js';
import Lang from './lang';
import Cookie from './cookie';


const tour = introJs()
    .onbeforechange(onbeforechange)
    .onexit(onexit);

function init() {
    tour.setOptions({
        showStepNumbers: false,
        keyboardNavigation: true,
        tooltipPosition: 'auto',
        positionPrecedence: ['left', 'right', 'top', 'bottom'],
        steps: [
            getStep('welcome', true),
            getStep('desk'),
            getStep('inventory'),
            getStep('categories'),
            getStep('catalog'),
            getStep('cart'),
            getStep('rotate'),
            getStep('sisal'),
            getStep('delete'),
            getStep('save'),
            getStep('colors'),
            getStep('intro'),
            getStep('buy'),
        ],
        nextLabel: Lang.get('intro.label.next'),
        prevLabel: Lang.get('intro.label.prev'),
        skipLabel: Lang.get('intro.label.skip'),
        doneLabel: Lang.get('intro.label.done'),
    });
}

function getStep(name, omitEl = false) {
    let $el = $(`[data-intro-id="${name}"]`);
    if($el.length > 1) $el = $el.filter(':visible');
    $el = $el[0];

    if(omitEl) $el = undefined;

    return {
        element: $el,
        intro: Lang.get(`intro.steps.${name}`)
    }
}

/**
 * Get step name by target element
 * @param {HTMLElement} target
 * @returns {string}
 */
function stepName(target) {
    return $(target).data('intro-id');
}

function onbeforechange(target) {
    const $el = {
        inventory: $('.inventory[data-inventory-id="main"]'),
        bar: $('[data-bar-id="actions"]'),
    };
    const cls = {
        inventoryOpen: 'inventory_open',
        barOpen: 'bar_open',
        btnHidden: 'btn_hidden'
    };

    let name = stepName(target);

    // bar (actions)
    if (name === 'sisal' || name === 'colors') $el.bar.addClass(cls.barOpen);
    if (name === 'cart' || name === 'intro') $el.bar.removeClass(cls.barOpen);

    // inventory (main)
    if (name === 'inventory' || name === 'cart') $el.inventory.addClass(cls.inventoryOpen);
    if (name === 'desk' || name === 'rotate') $el.inventory.removeClass(cls.inventoryOpen);
}

function onexit() {
    $('.js--trigger-rotate').addClass('btn_hidden');
    $('body').attr('data-intro-active', null);
}

function startTour() {
    $('.js--trigger-rotate').removeClass('btn_hidden');

    $('body').attr('data-intro-active', true);
    tour.start();
    Cookie.set('intro-done', true);
}

$(() => {
    Lang.promise.then(() => {
        init();
        if (!Cookie.get('intro-done')) {
            startTour();
        }
        $('.js--intro').on('click', startTour);
    });
});
